import { FunctionComponent, useEffect, useState } from 'react';
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';

export type CopyToClipboardProps = {
  copiedElement: React.ReactElement;
  copyElement: React.ReactElement;
  text: string;
};

export const CopyToClipboard: FunctionComponent<CopyToClipboardProps> = (
  props,
) => {
  const { copiedElement, copyElement, text } = props;
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let timeout: undefined | NodeJS.Timeout;
    if (copied) {
      timeout = setTimeout(() => setCopied(false), 500);
    }
    return () => clearTimeout(timeout);
  }, [copied]);

  return (
    <ReactCopyToClipboard text={text} onCopy={() => setCopied(true)}>
      {copied ? copiedElement : copyElement}
    </ReactCopyToClipboard>
  );
};
